import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './Markdown.module.css';

/**
 * Renderiza a resposta do assistente como markdown.
 *
 * O modelo usa negrito, listas e tabelas para comparar redes — sem isso o
 * operador lê `**Rede**` e `|---|---|` crus.
 *
 * HTML embutido no texto **não** é renderizado: o `react-markdown` ignora tags
 * cruas por padrão (não usamos `rehype-raw`), então texto vindo do modelo não
 * consegue injetar markup na página.
 */
const Markdown = ({ children }: { children: string }) => (
    <div className={styles.md}>
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                // Tabela larga rola dentro do próprio bloco em vez de esticar o painel.
                table: ({ node, ...props }) => (
                    <div className={styles.tabelaWrap}>
                        <table {...props} />
                    </div>
                ),
                a: ({ node, ...props }) => (
                    <a {...props} target="_blank" rel="noopener noreferrer" />
                ),
            }}
        >
            {children}
        </ReactMarkdown>
    </div>
);

export default Markdown;
